"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var addFolderIdToMoveToMruList_1 = require("./actions/addFolderIdToMoveToMruList");
exports.addFolderIdToMoveToMruList = addFolderIdToMoveToMruList_1.default;
var removeFolderIdFromMoveToMruList_1 = require("./actions/removeFolderIdFromMoveToMruList");
exports.removeFolderIdFromMoveToMruList = removeFolderIdFromMoveToMruList_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/data/owa-mail-move-mru/lib/lazyIndex.js
// module id = 2264
// module chunks = 51